import Home from "../Pages/Home";
import Portfolio from "../Pages/Portfolio";
import Terms from "../Pages/Terms";

export const pathsandelements = [

    {
        path: '/',
        element: <Home />
    },
    {
        path: '/portfolio',
        element: <Portfolio />
    },
    {
        path: '/terms',
        element: <Terms/>
    },


]